export const isEmptyCID = (cid: string | undefined): boolean => !cid || cid === 'ROOT';
